import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getPACKAGECODETableStructure";
export const UPDATE_TABLE_DATA = "getPACKAGECODETableData";
export const EXPORT_TABLE_DATA = "exportPACKAGECODETableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setPACKAGECODETableStructure";
export const SET_TABLE_DATA = "setPACKAGECODETableData";
export const SET_TABLE_FILTER = "setPACKAGECODETableFilter";
export const SET_TABLE_PAGE = "setPACKAGECODETablePage";
export const SET_TABLE_PERPAGE = "setPACKAGECODETablePerPage";
export const SET_TABLE_SORTBY = "setPACKAGECODETableSortBy";
export const SET_TABLE_SORTORDER = "setPACKAGECODETableSortOrder";
export const SET_EXPORT_LINK = "setPACKAGECODEExportLink";
export const SET_TABLE_SORT_BY = "setPACKAGECODETableSortBy";
export const SET_TABLE_PER_PAGE = "setPACKAGECODETTablePerPage";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getPACKAGECODETableProperties(state) {
    return state.table_structure.properties;
  },
  getPACKAGECODETablePermissions(state) {
    return state.table_structure.permissions;
  },
  getPACKAGECODETableState(state) {
    return state.table_state;
  },

  getPACKAGECODETableHeaders(state) {
    return state.table_structure.columns;
  },

  getPACKAGECODETableFilters(state) {
    return state.table_structure.filters;
  },

  getPACKAGECODETableData(state) {
    return state.table_data.data;
  },

  getPACKAGECODEExportUrl(state) {
    return state.export_link;
  },
  getPACKAGECODEUploadType(state) {
    return state.table_structure.type;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/custom/package_codes")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/package_codes/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/package_codes/export",
        payload
      )
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_TABLE_SORT_BY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_PER_PAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
